import React from "react";
import {
  AreaChart,
  Tooltip,
  Area,
  ResponsiveContainer,
  XAxis,
  YAxis,
  CartesianGrid,
} from "recharts";
import useInterval from "@rooks/use-interval";
import { useEffect, useState } from "react";
import axios from "../../../api/axios";
import CustomTooltip from "../../../utils/CustomTooltip";
import useAuth from "../../../hooks/authenticate/useAuth";

var request_updateTimelineData_safe = true;

var offset = new Date().getTimezoneOffset() / 60;
if (offset < 0) {
  offset *= -1;
  offset = Math.floor(offset);
}

function getLocalHour(date) {
  if (date) {
    let hour = new Date(date).getHours();
    return hour < 10 ? `0${hour}:00` : `${hour}:00`;
  }
}
function findHourData(timeline, hour) {
  for (let i = 0; i < timeline.length; i++) {
    if (timeline[i]["hour"] === hour) {
      return timeline[i];
    }
  }
  return -1;
}

function margeSameHours(timeline) {
  let temp = [];
  for (let i = 0; i < timeline.length; i++) {
    let currentChecker = timeline[i];
    for (let j = i + 1; j < timeline.length; j++) {
      if (
        parseInt(timeline[i]["hour"].split(":")[0]) ===
        parseInt(timeline[j]["hour"].split(":")[0])
      ) {
        currentChecker["northToEast"] += timeline[j]["northToEast"];
        currentChecker["westToEast"] += timeline[j]["westToEast"];
        currentChecker["eastToNorth"] += timeline[j]["eastToNorth"];
        currentChecker["eastToWest"] += timeline[j]["eastToWest"];
        currentChecker["total"] += timeline[j]["total"];
      }
    }
    temp.push(currentChecker);
  }

  return temp;
}

function fillLine(timeline) {
  let temp = [];

  // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
  for (let i = 0; i < new Date().getHours(); i++) {
    let hour = i < 10 ? `0${i}:00` : `${i}:00`;
    let res = findHourData(timeline, hour);

    if (res !== -1) {
      temp.push(res);
    } else {
      temp.push({
        hour: hour,
        vehicles: 0,
      });
    }
  }
  return temp;
}

const ChartStatisticsVehicles = () => {
  const [timelineData, setTimelineData] = useState([]);
  const { auth } = useAuth();
  const [finishSetup, setFinishSetup] = useState(false);

  const [loading, setLoading] = useState(true);

  function updateTimelineData() {
    if (request_updateTimelineData_safe === false) {
      return;
    } else {
      request_updateTimelineData_safe = false;
    }
    axios
      .get(
        `/v1/statistics/position/hour?token=${
          auth.token
        }&day=${new Date().getUTCDate()}&month=${new Date().getUTCMonth() + 1}`
        // {
        //   withCredentials: true,
        // }
      )
      .then((res) => {
        let timeline = [];
        for (let i = 0; i < res.data.length; i++) {
          for (let j = 0; j < res.data[i].length; j++) {
            // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
            if (
              parseInt(res.data[i][j]["hour"].split(":")[0]) <=
              new Date().getHours()
            ) {
              let eastToWestCount = res.data[i][j]["eastToWestCount"];
              let westToEastCount = res.data[i][j]["westToEastCount"];
              let northToEestCount = res.data[i][j]["northToEestCount"];
              let eastToNorthCount = res.data[i][j]["eastToNorthCount"];
              let total =
                eastToWestCount +
                westToEastCount +
                northToEestCount +
                eastToNorthCount;
              timeline.push({
                hour: getLocalHour(res.data[i][j]["date"]),
                eastToWest: eastToWestCount !== undefined ? eastToWestCount : 0,
                westToEast: westToEastCount !== undefined ? westToEastCount : 0,
                eastToNorth:
                  eastToNorthCount !== undefined ? eastToNorthCount : 0,
                northToEast:
                  northToEestCount !== undefined ? northToEestCount : 0,
                total: total !== undefined ? total : 0,
              });
            }
          }
        }
        // TODO: need to check if this if needed
        // if (JSON.stringify(timelineData) !== JSON.stringify(resData)) {
        timeline = margeSameHours(timeline);
        timeline = fillLine(timeline);
        setFinishSetup(true);

        setTimelineData((prev) => timeline);
        // setLoading(false);
        // if (totalCountVehicles !== totalVehicles) {
        //   setTotalCountVehicles((prev) => totalVehicles);
        // }
        request_updateTimelineData_safe = true;
      })
      .catch((err) => {
        console.log(
          "error with get hour statistic inside today vehicles-> ",
          err
        );
      });
  }

  useEffect(() => {
    updateTimelineData();
    setTimeout(() => {
      setLoading(false);
    }, 1030);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Get the up-to-date data for the in-out chart every 1 sec
  useInterval(
    () => {
      if (finishSetup) {
        updateTimelineData();
      } else updateTimelineData();
    },
    1000,
    true
  );

  if (loading) {
    return (
      <div className="bg-gray-300 flex-auto w-full h-full rounded-md overflow-hidden transition-all">
        <div className="w-full h-100 opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent  animate-slide"></div>
      </div>
    );
  }

  return (
    <div className="w-full h-full">
      <div className="flex flex-row justify-between">
        <div className="uppercase text-xs font-semibold text-gray-400">
          Today
        </div>
        <div className="flex flex-row space-x-2 items-center select-none"></div>
      </div>
      <div></div>
      <div className="font-bold text-xl text-gray-800">Vehicles</div>

      <div className="w-full h-5/6 bg-gray-100 bg-opacity-50">
        <div className="flex flex-row">
          <div className="flex items-center flex-wrap border-2 rounded-md bg-white">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 "
              viewBox="0 0 20 20"
              fill="rgb(59, 130, 246)"
            >
              <path
                fillRule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clipRule="evenodd"
              />
            </svg>
            <p className="text-base text-blue-500 opacity-80  px-1">
              West To East
            </p>
          </div>
          <div className="flex items-center flex-wrap border-2 rounded-md bg-white">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 "
              viewBox="0 0 20 20"
              fill="rgba(16, 185, 129)"
            >
              <path
                fillRule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clipRule="evenodd"
              />
            </svg>
            <p className="text-base text-green-500 opacity-80 px-1">
              East To West
            </p>
          </div>
          <div className="flex items-center flex-wrap border-2 rounded-md bg-white">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 "
              viewBox="0 0 20 20"
              fill="rgb(207, 19, 91)"
            >
              <path
                fillRule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clipRule="evenodd"
              />
            </svg>
            <p className="text-base text-red-500 opacity-80 px-1">
              East To North
            </p>
          </div>
          <div className="flex items-center flex-wrap border-2 rounded-md bg-white">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 "
              viewBox="0 0 20 20"
              fill="rgb(250, 207, 19)"
            >
              <path
                fillRule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clipRule="evenodd"
              />
            </svg>
            <p className="text-base text-yellow-500 opacity-80 px-1">
              North To East
            </p>
          </div>
        </div>

        <ResponsiveContainer>
          <AreaChart
            data={timelineData}
            margin={{ top: 5, right: 12, left: 6, bottom: 14 }}
          >
            <defs>
              {/* <linearGradient id="leaving" x1="0" y1="0" x2="0" y2="1">
              <stop offset="100%" stopColor="rgb(156, 163, 175)" />
            </linearGradient> */}
              <linearGradient id="eastToWest" x1="0" y1="0" x2="0" y2="1">
                <stop
                  offset="100%"
                  stopColor=" rgba(52, 211, 153)"
                  opacity={0.6}
                />
              </linearGradient>
              <linearGradient id="westToEast" x1="0" y1="0" x2="0" y2="1">
                <stop
                  offset="100%"
                  stopColor="rgb(59, 130, 246)"
                  opacity={0.5}
                />
              </linearGradient>
              <linearGradient id="eastToNorth" x1="0" y1="0" x2="0" y2="1">
                <stop
                  offset="100%"
                  stopColor="rgb(207, 19, 91)"
                  opacity={0.5}
                />
              </linearGradient>
              <linearGradient id="northToeast" x1="0" y1="0" x2="0" y2="1">
                <stop
                  offset="100%"
                  stopColor="rgb(194, 207, 19)"
                  opacity={0.5}
                />
              </linearGradient>
            </defs>
            <Tooltip
              coordinate={{ x: 0, y: 0 }}
              offset={0}
              allowEscapeViewBox={{ x: false, y: true }}
              content={<CustomTooltip />}
            />
            <XAxis
              axisLine={false}
              tick={{ fontSize: "0.5rem" }}
              interval="preserveStartEnd"
              // interval={0}
              // angle={-10}
              // dx={20}
              // dy={10}
              height={15}
              dataKey="hour"
            />
            <YAxis
              axisLine={false}
              tickLine={true}
              // mirror={true}
              tick={{ fontSize: "0.6rem" }}
              // allowDataOverflow={false}
              // tickMargin={5}
              width={30}
              // dx={10}
              // hide={true}
              interval="preserveStartEnd"
              dataKey="total"
            />
            <CartesianGrid strokeDasharray="3 3" />
            <Area
              type="natural"
              dataKey="eastToWest"
              stroke="rgba(52, 211, 153)"
              strokeWidth={2}
              fillOpacity={0.6}
              fill={"url(#eastToWest)"}
            />
            <Area
              type="natural"
              dataKey="westToEast"
              stroke="rgb(59, 130, 246)"
              strokeWidth={2}
              fillOpacity={0.3}
              fill={"url(#westToEast)"}
            />
            <Area
              type="natural"
              dataKey="eastToNorth"
              stroke="rgb(207, 19, 91)"
              strokeWidth={2}
              fillOpacity={0.3}
              fill={"url(#eastToNorth)"}
            />
            <Area
              type="natural"
              dataKey="northToEast"
              stroke="rgb(194, 207, 19)"
              strokeWidth={2}
              fillOpacity={0.3}
              fill={"url(#northToEast)"}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ChartStatisticsVehicles;
